import { useEffect } from "react";

// For screens without a PageHeader, such as sign-in.
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = `${title} · SafePlate`;
  }, [title]);
}
